/* eslint react/prop-types: 0 */

import React, { useState, useEffect } from "react";
import { Loader, Button } from "semantic-ui-react";
import { useSelector } from "react-redux";
import numeral from "numeral";
import { InputFieldResponsive, InputFieldResponsive2 } from "../../component/Utils";
import { anggaran as formula } from "../../utils/financeFormula";
import Table from 'react-bootstrap/Table';
import { rkapPercentage } from "../../utils/helper";

export const Laba = (props) => {
  const user = useSelector((state) => state.main.dataUser);
  const filter = useSelector((state) => state.main);
  const reportReducer = useSelector((state) => state.reportReducer);

  const disabledInput = user.role < 4;

  const [dataInput, setDataInput] = useState({});

  const handleChange = (event) => {
    const { name, value } = event.target;
    const stringFields = ["catatan"];
    let v = value;
    if (stringFields.indexOf(name) < 0) v = parseInt(value);
    setDataInput({
      ...dataInput,
      [name]: v,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    props.postData(dataInput);
  };

  useEffect(() => {
    const data = reportReducer.dataReport
      ? reportReducer.dataReport.content[0]
      : null;
    setDataInput({
      ...data,
      pendapatan: data ? data.pendapatan : null,
      bebanPendapatan: data ? data.bebanPendapatan : null,
      bebanMaterial: data ? data.bebanMaterial : null,
      bebanPegawai: data ? data.bebanPegawai : null,
      factoryOverhead: data ? data.factoryOverhead : null,
      bebanCsr: data ? data.bebanCsr : null,
      jumlahBebanPendapatan: data ? data.jumlahBebanPendapatan : null,
      bebanPenjualan: data ? data.bebanPenjualan : null,
      bebanAdministrasi: data ? data.bebanAdministrasi : null,
      bebanOperasionalLainnya: data ? data.bebanOperasionalLainnya : null,
      jumlahBebanUsaha: data ? data.jumlahBebanUsaha : null,
      pendapatanLain: data ? data.pendapatanLain : null,
      pbpAktivaTetap: data ? data.pbpAktivaTetap : null,
      pbpAktivaNonproduktif: data ? data.pbpAktivaNonproduktif : null,
      pbpAktivaLainnya: data ? data.pbpAktivaLainnya : null,
      pbpSahamPenyertaan: data ? data.pbpSahamPenyertaan : null,
      pendapatanBunga: data ? data.pendapatanBunga : null,
      jumlahPbLainnya: data ? data.jumlahPbLainnya : null,
      labaSebelumPp: data ? data.labaSebelumPp : null,
      pajakKini: data ? data.pajakKini : null,
      pajakTangguhan: data ? data.pajakTangguhan : null,
      itbSetelahPajak: data ? data.itbSetelahPajak : null,
      pbKomperhensifLain: data ? data.pbKomperhensifLain : null,
      bebanLain: data ? data.bebanLain : null,
      bebanPenyusutan: data ? data.bebanPenyusutan : null,
      bebanBunga: data ? data.bebanBunga : null,
      bebanPajak: data ? data.bebanPajak : null,

      rkapPendapatan: data ? data.rkapPendapatan : null,
      rkapBebanPendapatan: data ? data.rkapBebanPendapatan : null,
      rkapBebanPenjualan: data ? data.rkapBebanPenjualan : null,
      rkapBebanAdministrasi: data ? data.rkapBebanAdministrasi : null,
      rkapBebanLain: data ? data.rkapBebanLain : null,
      rkapBebanPenyusutan: data ? data.rkapBebanPenyusutan : null,
      rkapBebanBunga: data ? data.rkapBebanBunga : null,
      rkapBebanPajak: data ? data.rkapBebanPajak : null,
      rkapBebanOperasionalLainnya: data ? data.rkapBebanOperasionalLainnya : null,
      rkapBebanMaterial: data ? data.rkapBebanMaterial : null,
      rkapBebanPegawai: data ? data.rkapBebanPegawai : null,
      rkapFactoryOverhead: data ? data.rkapFactoryOverhead : null,
      rkapBebanCsr: data ? data.rkapBebanCsr : null,
      rkapJumlahBebanPendapatan: data ? data.rkapJumlahBebanPendapatan : null,
      rkapJumlahBebanUsaha: data ? data.rkapJumlahBebanUsaha : null,
      rkapPendapatanLain: data ? data.rkapPendapatanLain : null,
      rkapPbpAktivaTetap: data ? data.rkapPbpAktivaTetap : null,
      rkapPbpAktivaNonproduktif: data ? data.rkapPbpAktivaNonproduktif : null,
      rkapPbpAktivaLainnya: data ? data.rkapPbpAktivaLainnya : null,
      rkapPbpSahamPenyertaan: data ? data.rkapPbpSahamPenyertaan : null,
      rkapPendapatanBunga: data ? data.rkapPendapatanBunga : null,
      rkapJumlahPbLainnya: data ? data.rkapJumlahPbLainnya : null,
      rkapLabaSebelumPp: data ? data.rkapLabaSebelumPp : null,
      rkapPajakKini: data ? data.rkapPajakKini : null,
      rkapPajakTangguhan: data ? data.rkapPajakTangguhan : null,
      rkapItbSetelahPajak: data ? data.rkapItbSetelahPajak : null,
      rkapPbKomperhensifLain: data ? data.rkapPbKomperhensifLain : null,
    });
  }, [reportReducer.dataReport]);

  if (reportReducer.isLoading) {
    return (
      <div className="w-100 d-flex justify-content-center">
        <Loader active>Loading</Loader>
      </div>
    );
  }

  return (
    <>
      <h3 className="mb-4">
        Laporan Laba Rugi - {filter.labelMonth} {filter.yearFilter}
      </h3>

      <Table bordereless hover>
        <thead>
          <tr>
            <td></td>
            <th width={"33%"}>Realisasi</th>
            <th width={"34%"}>RKAP</th>
            <th width={"5%"}>%</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Pendapatan Usaha</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.pendapatan,
                  name: "pendapatan",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapPendapatan,
                  name: "rkapPendapatan",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(dataInput.pendapatan, dataInput.rkapPendapatan)}
            </td>
          </tr>
          <tr>
            <th>BEBAN POKOK PENDAPATAN</th>
          </tr>
          <tr>
            <td>Beban Material</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.bebanMaterial,
                  name: "bebanMaterial",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapBebanMaterial,
                  name: "rkapBebanMaterial",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.bebanMaterial,
                dataInput.rkapBebanMaterial
              )}
            </td>
          </tr>
          <tr>
            <td>Beban Pegawai</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.bebanPegawai,
                  name: "bebanPegawai",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapBebanPegawai,
                  name: "rkapBebanPegawai",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.bebanPegawai,
                dataInput.rkapBebanPegawai
              )}
            </td>
          </tr>
          <tr>
            <td>Factory Overhead</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.factoryOverhead,
                  name: "factoryOverhead",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapFactoryOverhead,
                  name: "rkapFactoryOverhead",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.factoryOverhead,
                dataInput.rkapFactoryOverhead
              )}
            </td>
          </tr>
          <tr>
            <th>Jumlah Beban Pokok Pendapatan</th>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.jumlahBebanPendapatan(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.rkapJumlahBebanPendapatan(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              {rkapPercentage(
               formula.jumlahBebanPendapatan(dataInput),
               formula.rkapJumlahBebanPendapatan(dataInput)
              )}
            </td>
          </tr>
          <tr>
            <th>LABA BRUTO</th>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.labaKotor(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.rkaplabaKotor(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              {rkapPercentage(
                formula.labaKotor(dataInput),
                formula.rkaplabaKotor(dataInput)
              )}
            </td>
          </tr>
          <tr>
            <th>BEBAN USAHA</th>
          </tr>
          <tr>
            <td>Beban Administrasi dan Umum</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.bebanAdministrasi,
                  name: "bebanAdministrasi",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapBebanAdministrasi,
                  name: "rkapBebanAdministrasi",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.bebanAdministrasi,
                dataInput.rkapBebanAdministrasi
              )}
            </td>
          </tr>
          <tr>
            <td>Beban Pendapatan dan Pemasaran</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.bebanPendapatan,
                  name: "bebanPendapatan",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapBebanPendapatan,
                  name: "rkapBebanPendapatan",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.bebanPendapatan,
                dataInput.rkapBebanPendapatan
              )}
            </td>
          </tr>
          <tr>
            <td>Beban CSR</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.bebanCsr,
                  name: "bebanCsr",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapBebanCsr,
                  name: "rkapBebanCsr",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(dataInput.bebanCsr, dataInput.rkapBebanCsr)}
            </td>
          </tr>
          <tr>
            <td>Beban Penyusutan dan Amortisasi</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.bebanPenyusutan,
                  name: "bebanPenyusutan",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapBebanPenyusutan,
                  name: "rkapBebanPenyusutan",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.bebanPenyusutan,
                dataInput.rkapBebanPenyusutan
              )}
            </td>
          </tr>
          <tr>
            <th>Jumlah Beban Usaha</th>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.jumlahBebanUsaha(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.rkapJumlahBebanUsaha(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              {rkapPercentage(
              formula.jumlahBebanUsaha(dataInput),
              formula.rkapJumlahBebanUsaha(dataInput)
              )}
            </td>
          </tr>
          <tr>
            <th>LABA USAHA</th>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.labaUsaha(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.rkaplabaUsaha(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              {rkapPercentage(
                formula.labaUsaha(dataInput),
                formula.rkaplabaUsaha(dataInput)
              )}
            </td>
          </tr>
          <tr>
            <th>Pendapatan (Beban) dan Lain-lain</th>
          </tr>
          <tr>
            <td>Pendapatan (Beban) Penjualan Aktiva Tetap</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.pbpAktivaTetap,
                  name: "pbpAktivaTetap",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapPbpAktivaTetap,
                  name: "rkapPbpAktivaTetap",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.pbpAktivaTetap,
                dataInput.rkapPbpAktivaTetap
              )}
            </td>
          </tr>
          <tr>
            <td>Pendapatan (Beban) Penjualan Aktiva Non Produktif</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.pbpAktivaNonproduktif,
                  name: "pbpAktivaNonproduktif",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapPbpAktivaNonproduktif,
                  name: "rkapPbpAktivaNonproduktif",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.pbpAktivaNonproduktif,
                dataInput.rkapPbpAktivaNonproduktif
              )}
            </td>
          </tr>
          <tr>
            <td>Pendapatan (Beban) Penjualan Aktiva Lain-lain</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.pbpAktivaLainnya,
                  name: "pbpAktivaLainnya",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapPbpAktivaLainnya,
                  name: "rkapPbpAktivaLainnya",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.pbpAktivaLainnya,
                dataInput.rkapPbpAktivaLainnya
              )}
            </td>
          </tr>
          <tr>
            <td>Pendapatan (Beban) Penjualan Saham Penyertaan Langsung</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.pbpSahamPenyertaan,
                  name: "pbpSahamPenyertaan",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapPbpSahamPenyertaan,
                  name: "rkapPbpSahamPenyertaan",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.pbpSahamPenyertaan,
                dataInput.rkapPbpSahamPenyertaan
              )}
            </td>
          </tr>
          <tr>
            <td>Pendapatan Bunga</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.pendapatanBunga,
                  name: "pendapatanBunga",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapPendapatanBunga,
                  name: "rkapPendapatanBunga",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.pendapatanBunga,
                dataInput.rkapPendapatanBunga
              )}
            </td>
          </tr>
          <tr>
            <td>Beban Bunga</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.bebanBunga,
                  name: "bebanBunga",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapBebanBunga,
                  name: "rkapBebanBunga",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(dataInput.bebanBunga, dataInput.rkapBebanBunga)}
            </td>
          </tr>
          <tr>
            <td>Pendapatan Lain-lain</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.pendapatanLain,
                  name: "pendapatanLain",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapPendapatanLain,
                  name: "rkapPendapatanLain",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.pendapatanLain,
                dataInput.rkapPendapatanLain
              )}
            </td>
          </tr>
          <tr>
            <td>Beban Lain-lain</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.bebanLain,
                  name: "bebanLain",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapBebanLain,
                  name: "rkapBebanLain",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(dataInput.bebanLain, dataInput.rkapBebanLain)}
            </td>
          </tr>
          <tr>
            <td>Jumlah Pendapatan (Beban) Lain-lain</td>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.jumlahPendapatanLain(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.rkapJumlahPendapatanLain(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              {rkapPercentage(
                formula.jumlahPendapatanLain(dataInput),
                formula.rkapJumlahPendapatanLain(dataInput)
              )}
            </td>
          </tr>
          <tr>
            <th>LABA SEBELUM PAJAK PENGHASILAN</th>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.labaSebelumPajakPenghasilan(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.rkaplabaSebelumPajakPenghasilan(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              {rkapPercentage(
                formula.labaSebelumPajakPenghasilan(dataInput),
                formula.rkaplabaSebelumPajakPenghasilan(dataInput)
              )}
            </td>
          </tr>
          <tr>
            <th>MANFAAT (BEBAN) PAJAK PENGHASILAN</th>
          </tr>
          <tr>
            <td>Pajak Kini</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.pajakKini,
                  name: "pajakKini",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapPajakKini,
                  name: "rkapPajakKini",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(dataInput.pajakKini, dataInput.rkapPajakKini)}
            </td>
          </tr>
          <tr>
            <td>Pajak Tangguhan</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.pajakTangguhan,
                  name: "pajakTangguhan",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapPajakTangguhan,
                  name: "rkapPajakTangguhan",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.pajakTangguhan,
                dataInput.rkapPajakTangguhan
              )}
            </td>
          </tr>
          <tr>
            <th>LABA TAHUN BERJALAN SETELAH PAJAK</th>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.labaTahunBerjalanSetelahPajak(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.rkaplabaTahunBerjalanSetelahPajak(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              {rkapPercentage(
             formula.labaTahunBerjalanSetelahPajak(dataInput),
             formula.rkaplabaTahunBerjalanSetelahPajak(dataInput)
              )}
            </td>
          </tr>
          <tr>
            <th>PENDAPATAN (BEBAN) KOMPREHENSIF LAIN</th>
          </tr>
          <tr>
            <td>pendapatan (Beban) Komprehensif Lain</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.pbKomperhensifLain,
                  name: "pbKomperhensifLain",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapPbKomperhensifLain,
                  name: "rkapPbKomperhensifLain",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.pbKomperhensifLain,
                dataInput.rkapPbKomperhensifLain
              )}
            </td>
          </tr>
          <tr>
            <th>LABA BERSIH KOMPREHENSIF TAHUN BERJALAN</th>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.labaBersih(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.rkaplabaBersih(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              {rkapPercentage(
                formula.labaBersih(dataInput),
                formula.rkaplabaBersih(dataInput)
              )}
            </td>
          </tr>
          <tr>
            <th>EBIT</th>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.ebit(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.rkapebit(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              {rkapPercentage(
                formula.ebit(dataInput),
                formula.rkapebit(dataInput)
              )}
            </td>
          </tr>
          <tr>
            <th> EBITDA</th>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.ebitda(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.rkapebitda(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              {rkapPercentage(
               formula.ebitda(dataInput),
               formula.rkapebitda(dataInput)
              )}
            </td>
          </tr>
          <tr>
            <td>Catatan</td>
            <td>
              <InputFieldResponsive2
                label="Catatan"
                inputType={{
                  disabled: disabledInput,
                  type: "textarea",
                  name: "catatan",
                  value: dataInput.catatan,
                }}
                onChange={handleChange}
              />
            </td>
          </tr>
        </tbody>
      </Table>

      {!disabledInput && (
        <Button
          color="blue"
          disabled={props.isLoadingButton}
          loading={props.isLoadingButton}
          onClick={handleSubmit}
        >
          Simpan
        </Button>
      )}
    </>
  );
};
